import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// export default new Router({
//   mode: 'history',
  const routes = [
    // 登录
    {
      path: '/login',
      name: 'Login',
      component: () => import("@/components/login/Login"),
      
    },
    {
      path: '/',
      name: 'HelloWorld',
      component: () => import("@/components/HelloWorld"),
      redirect() {
        return '/login'
      }
    },
    // 注册
    {
      path: '/register',
      name: 'Register',
      component: () => import("@/components/login/Register"),
    },
    // 忘记密码
    {
      path: '/forget',
      name: 'Forget',
      component: () => import("@/components/login/Forget"),
      // meta: { requireAuth: true }
    },
    {
      path: '/login_callback',
      name: 'Login_callback',
      component: () => import("@/components/port/Login_callback"),
      beforeRouteLeave(to, from, next) {
        if (Cookies.get('tokenid')) {
          next()
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import("@/components/port/Logout"),
    },
    {
      path: '/sign',
      component: () => import("@/components/port/Sign"),
    },
    // home
    {
      path: '/home',
      name: 'home',
      component: () => import("@/components/Home"),
    },
    // 使用协议
    {
      path: '/protocol',
      name: 'Protocol',
      component: () => import("@/components/clause/Protocol"),
    },
    // 隐私政策
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import("@/components/clause/Privacy"),
    },
    // 信息声明
    {
      path: '/statement',
      component: () => import("@/components/clause/Statement"),
    },
    // 尾部组件
    {
      path: '/footer',
      component: () => import("@/components/port/Footer"),
    },
    // 头部组件
    {
      path: '/header',
      component: () => import("@/components/port/Header"),
    },
    // 支持的国家和地区
    {
      path: '/support',
      component: () => import("@/components/clause/Support"),
    },
    // 帮助
    {
      path: '/help',
      component: () => import("@/components/clause/Help"),
    },
    // 页面不存在
    {
      path: '/404',
      name:'notFound',
      component: () => import("@/components/port/404"),
    },
    // 页面不存在
    {
      path: '/500',
      component: () => import("@/components/port/500"),
    },
    // 订阅页
    {
      path: '/store/plan',
      component: () => import("@/components/subscription"),
    },
    // 支付结果页
    {
      path: '/result',
      component: () => import("@/components/plan/Result"),
    },
    // 支付页
    {
      path: '/payment',
      name:'payment',
      component: () => import("@/components/plan/Payment"),
    },
    // 新增页
    {
      path: '/v1/api/login',
      component: () => import("@/components/Api_login"),
    },
    {
      path: '/v1/api/logout',
      component: () => import("@/components/Api_logout"),
    },
    // plan完成页
    {
      path: '/plan_complete',
      name:'/plan_complete',
      component: () => import("@/components/plan/Plan_complete"),
    },
    // 方案详情页
    {
      path: '/details_plan',
      name:'details_plan',
      component: () => import("@/components/plan/Details_plan"),
    },
    {
      path: '/getToken',
      component: () => import("@/components/port/GetToken"),
    },
    // 使用中的计划
    {
      path: '/in_use',
      component: () => import("@/components/home/In_use"),
    },
    // 历史中的计划
    {
      path: '/history',
      component: () => import("@/components/home/history"),
    },
    // 暂停服务
    {
      path: '/suspend',
      component: () => import("@/components/suspend"),
    },
    // 未支付订单
    {
      path: '/unpaid',
      component: () => import("@/components/plan/Unpaid"),
    },
    {
      path: "*",
      redirect: '/404'
    }
  ]
// })

const router = new Router({
  routes:routes,
  mode: 'history'
})

router.beforeEach((to,from,next)=>{
  let id = '';  
  while (id.length < 10) {  
    id += Math.floor(Math.random() * 10).toString();  
  }  
  id = parseInt(id).toString().padStart(10, '0'); 
  axios.get(`/static/config.json?id=${id}`).then(result => {
    console.log(result.data.renew)
    if(result.data.renew === true){
      if(to.path == '/suspend'){
        next()
      }else{
        next('/suspend')
      }
    }else{
      if(to.path == '/suspend'){
        next('/')
      }else{
        next()
      }
    }
  }).catch(error => {})
    
  // }else{
  //   console.log('不是true 2222')
  //   if(to.path == '/suspend'){
  //     next('/')
  //   }else{
  //     next()
  //   }
  // }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js